import React, { useState } from "react";
import styles from '../index.module.css';
import LoginLogo from '../../../../assets/images/brand/login_logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signUpSubmit } from "../../../../redux/features/auth/authService";
import BeatLoader from "react-spinners/BeatLoader";

const SignUp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isSignUpLoading } = useSelector((state) => state.auth.signUpDetails)

    const [formData, setFormData] = useState({
        full_name: '',
        nic: '',
        email: '',
        username: '',
        phone_number: '',
        password: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        full_name: '',
        nic: '',
        email: '',
        username: '',
        phone_number: '',
        password: '',
    });
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const validateFormData = (data) => {
        const errors = {};

        const validateNicNumber = (nic) => /^(?:\d{9}[xXvV]|\d{12})$/.test(nic);
        const validateEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        if (!data.full_name) {
            errors.full_name = 'Full Name is required.';
        }
        if (!data.nic) {
            errors.nic = 'NIC Number is required.';
        } else if (!validateNicNumber(data.nic)) {
            errors.nic = 'NIC must be a valid number (e.g., 9 digits + V/X or 12 digits).';
        }
        if (!data.email) {
            errors.email = 'Email is required.';
        } else if (!validateEmail(data.email)) {
            errors.email = 'Email address must be a valid email.';
        }
        if (!data.username) {
            errors.username = 'Username is required.';
        }
        if (!data.phone_number) {
            errors.phone_number = 'Phone Number is required.';
        }
        if (!data.password) {
            errors.password = 'Password is required.';
        }
        if (!data.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required.';
        }
        if (data.password !== data.confirmPassword) {
            errors.confirmPassword = 'Password & Confirm Password should be matched.';
        }

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const register = async () => {
        setErrorMsg('');
        const trimmedFormData = {
            full_name: formData.full_name?.trim(),
            nic: formData.nic?.trim(),
            email: formData.email?.trim(),
            username: formData.username?.trim(),
            phone_number: formData.phone_number?.trim(),
            password: formData.password,
            confirmPassword: formData.confirmPassword
        };
        const email = trimmedFormData.email;
        try {
            if (validateFormData(trimmedFormData)) {
                const response = await dispatch(signUpSubmit(trimmedFormData)).unwrap();
                if (response.success) {
                    navigate('/auth/verify', { state: { email: email } });
                }
            }
        } catch (err) {
            setErrorMsg(err.message);
        }
    }

    const goHome = () => {
        navigate('/');
    }

    return (
        <>
            <div className={styles.authContainer}>
                <div className={styles.authCard}>
                    <div className={styles.authCardHeader}>
                        <img src={LoginLogo} alt="Logo" className={styles.logoImg} onClick={goHome} />
                        <h1 className={styles.authTitle} style={{ marginBottom: '15px' }}>Sign up with us</h1>
                        <div className={styles.subTitleRow}>
                            <p>
                                Already have an account?{" "}
                                <Link to="/auth/login" className={styles.loginLink}>
                                    Login
                                </Link>
                            </p>
                        </div>
                    </div>
                    <div className={styles.authCardBody}>
                        <div className={styles.formContainer}>
                            <form noValidate>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Full Name
                                        </label>
                                        <input
                                            type='text'
                                            id='full_name'
                                            name='full_name'
                                            value={formData.full_name}
                                            onChange={handleInputChange}
                                            placeholder='Enter your full name'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.full_name && (
                                            <p className={`text-danger`}>{errorMessages.full_name}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Email Address
                                        </label>
                                        <input
                                            type='text'
                                            id='email'
                                            name='email'
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder='Enter your email address'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.email && (
                                            <p className={`text-danger`}>{errorMessages.email}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Username
                                        </label>
                                        <input
                                            type='text'
                                            id='username'
                                            name='username'
                                            value={formData.username}
                                            onChange={handleInputChange}
                                            placeholder='Enter your username'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.username && (
                                            <p className={`text-danger`}>{errorMessages.username}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            NIC
                                        </label>
                                        <input
                                            type='text'
                                            id='nic'
                                            name='nic'
                                            value={formData.nic}
                                            onChange={handleInputChange}
                                            placeholder='Enter your NIC Number'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.nic && (
                                            <p className={`text-danger`}>{errorMessages.nic}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Phone Number
                                        </label>
                                        <input
                                            type='text'
                                            id='phone_number'
                                            name='phone_number'
                                            value={formData.phone_number}
                                            onChange={handleInputChange}
                                            placeholder='Enter your phone number'
                                            className={`form-input-default`}
                                        />
                                        {errorMessages.phone_number && (
                                            <p className={`text-danger`}>{errorMessages.phone_number}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group password-container`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Password
                                        </label>
                                        <div className={`password-wrapper`}>
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                id='password'
                                                name='password'
                                                placeholder="Enter your password"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                            <FontAwesomeIcon
                                                icon={!passwordVisible ? faEyeSlash : faEye}
                                                onClick={() => setPasswordVisible(!passwordVisible)}
                                                className={`password-icon`}
                                            />
                                        </div>
                                        {errorMessages.password && (
                                            <p className={`text-danger`}>{errorMessages.password}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group password-container`}>
                                        <label htmlFor='full_name' className={`form-label`}>
                                            Confirm Password
                                        </label>
                                        <div className={`password-wrapper`}>
                                            <input
                                                type={confirmPasswordVisible ? "text" : "password"}
                                                id='confirmPassword'
                                                name='confirmPassword'
                                                placeholder="Re enter your password"
                                                value={formData.confirmPassword}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                            <FontAwesomeIcon
                                                icon={!confirmPasswordVisible ? faEyeSlash : faEye}
                                                onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                                className={`password-icon`}
                                            />
                                        </div>
                                        {errorMessages.confirmPassword && (
                                            <p className={`text-danger`}>{errorMessages.confirmPassword}</p>
                                        )}
                                    </div>
                                </div>
                                {errorMsg && (
                                    <p className={`text-danger`}>{errorMsg}</p>
                                )}
                                <button
                                    className={styles.authBtn}
                                    type='button'
                                    disabled={isSignUpLoading}
                                    onClick={register}
                                >
                                    {isSignUpLoading ? <BeatLoader color='#ffffff' /> : `Create Account`}
                                </button>
                            </form>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default SignUp;